import regeneratorRuntime from "regenerator-runtime";
import AjaxJs from "./ajax";
const ajax = new AjaxJs();

//Expects _ECommFieldsets.cshtml to be present
export default class ECommForm {

    constructor(container$) {
        this.container$ = container$;

        this.errorContainer$ = container$.find(".error");

        this.checkbox$ = container$.find("[name='addresssame']");

        const sections$ = container$.find("[name='Customer'] > *");
        this.namesection$ = sections$.filter("[name='Names']");
        this.contactsection$ = sections$.filter("[name='Contacts']");

        this.shippingsection$ = sections$.filter("[name='ShippingAddress']");
        this.billingsection$ = sections$.filter("[name='BillingAddress']");

        this.paymentSection$ = sections$.filter("[name='Payment']");

        this.checkbox$.on("change", () => {
            if (this.billingIsShipping()) {
                this.shippingsection$.hide();
                this.shippingsection$.find("input,textarea,select").attr("disabled", "disabled");
            } else {
                this.shippingsection$.show();
                this.shippingsection$.find("input,textarea,select").removeAttr("disabled");
            }
        });
    }

    showError() {
        this.errorContainer$.show();
    }

    hideError() {
        this.errorContainer$.hide();
    }

    billingIsShipping() {
        return this.checkbox$.is(":checked");
    }

    getCustomerInfo() {
        return {
            Info: {
                ExternalID: this.container$.find("[name='ExternalID']").val(),
                FirstName: this.namesection$.find("[name='FirstName']").val(),
                LastName: this.namesection$.find("[name='LastName']").val(),
                EmailAddress: this.contactsection$.find("[name='EmailAddress']").val(),
                Phone: this.contactsection$.find("[name='Phone']").val(),
                CellPhone: this.contactsection$.find("[name='CellPhone']").val(),
            },
            ShippingAddress:
                (this.billingIsShipping() ? this.billingsection$ : this.shippingsection$)
                .find("input, select")
                .toArray()
                .reduce((prev, curr) => {
                    prev[curr.name] = curr.value;
                    return prev;
                }, {}),
            BillingAddress: this.billingsection$
                .find("input, select")
                .toArray()
                .reduce((prev, curr) => {
                    prev[curr.name] = curr.value;
                    return prev;
                }, {}),
            Payment: this.paymentSection$
                .find("input")
                .toArray()
                .reduce((prev, curr) => {
                    prev[curr.name] = curr.value;
                    return prev;
                }, {})
        };
    }
};


// WEBPACK FOOTER //
// ./Scripts/es6/ecommForm.js